<template>
  <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow navbar-expand-lg">
    <div class="container-fluid p-0">
      <h3 class="navbar-brand col-sm-3 col-md-2 mr-0 mb-0">
        <router-link :to="{ name: user ? 'home' : 'login' }">
          <logo />
        </router-link>
      </h3>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false">
        <span class="navbar-toggler-icon"/>
      </button>

      <div id="navbarToggler" class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <!-- Authenticated -->
          <li v-if="user && user.role > 1" class="nav-item dropdown">
            <router-link :to="{ name: 'printables.order' }" class="nav-link text-success">
              Beställ artikel
            </router-link>
          </li>

          <li v-if="user && user.role == 4" class="nav-item dropdown">
            <router-link :to="{ name: 'printables.create' }" class="nav-link text-success">
              Skapa ny artikel
            </router-link>
          </li>
          <li v-if="user && user.role == 4" class="nav-item dropdown">
            <router-link :to="{ name: 'components.create' }" class="nav-link text-success">
              Ladda upp komponent
            </router-link>
          </li>

          <li v-if="user && user.role == 4 || user && company.id == 2" class="nav-item dropdown">
            <router-link :to="{ name: 'external' }" class="nav-link text-success">
              Externa terminalkartor
            </router-link>
          </li>
          <!--<li v-if="user && user.role == 4" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle"
               href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <fa :icon="['fal','plus-circle']" /> Skapa ny
            </a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'admin.companies' }" class="dropdown-item pl-3">
                <fa :icon="['fal','truck']" fixed-width/>
                {{ $t('companies') }}
              </router-link>

              <router-link :to="{ name: 'admin.printabletypes' }" class="dropdown-item pl-3">
                <fa :icon="['fal','newspaper']" fixed-width/>
                {{ $t('printabletypes') }}
              </router-link>

              <router-link :to="{ name: 'admin.templates' }" class="dropdown-item pl-3">
                <fa :icon="['fal','puzzle-piece']" />

                {{ $t('templates') }}
              </router-link>

              <router-link :to="{ name: 'admin.users' }" class="dropdown-item pl-3">
                <fa :icon="['fal','users']" fixed-width/>
                {{ $t('users') }}
              </router-link>
            </div>
          </li>-->
          <li v-if="user && user.role == 4" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle"
               href="#" role="button" aria-haspopup="true" aria-expanded="false" @click="toggleAdmin = !toggleAdmin">
              <fa :icon="['fal','unlock-alt']" /> Administrera
            </a>
            <div :class="[toggleAdmin && 'd-block']" class="dropdown-menu" @click="toggleAdmin = false">

              <router-link :to="{ name: 'admin.companies' }" class="dropdown-item pl-3">
                <fa :icon="['fal','truck']" fixed-width/>
                {{ $t('companies') }}
              </router-link>

              <router-link :to="{ name: 'admin.printabletypes' }" class="dropdown-item pl-3">
                <fa :icon="['fal','newspaper']" fixed-width/>
                {{ $t('printabletypes') }}
              </router-link>

              <router-link :to="{ name: 'admin.templates' }" class="dropdown-item pl-3">
                <fa :icon="['fal','puzzle-piece']" />

                {{ $t('templates') }}
              </router-link>

              <router-link :to="{ name: 'admin.users' }" class="dropdown-item pl-3">
                <fa :icon="['fal','users']" fixed-width/>
                {{ $t('users') }}
              </router-link>

              <router-link :to="{ name: 'admin.projects' }" class="dropdown-item pl-3">
                <fa :icon="['fal','project-diagram']" fixed-width/>
                {{ $t('projects') }}
              </router-link>
            </div>
          </li>
          <li v-if="user" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" aria-haspopup="true" aria-expanded="false" @click="toggleUser = !toggleUser">
              <fa :icon="['fal','user']" /> {{ user.name }}
            </a>
            <div :class="[toggleUser && 'd-block']" class="dropdown-menu m-0 ml-1">
              <router-link :to="{ name: 'settings.profile' }" class="dropdown-item pl-3">
                <fa :icon="['fal','cog']" fixed-width/>
                {{ $t('settings') }}
              </router-link>

              <router-link :to="{ name: 'settings.password' }" class="dropdown-item pl-3">
                <fa :icon="['fal','lock']" fixed-width/>
                {{ $t('password') }}
              </router-link>

              <div class="dropdown-divider"/>
              <a href="#" class="dropdown-item pl-3" @click.prevent="logout">
                <fa :icon="['fal','sign-out-alt']" fixed-width/>
                {{ $t('logout') }}
              </a>
            </div>
          </li>
          <!-- Guest -->
          <template v-else>
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" class="nav-link" active-class="active">
                {{ $t('login') }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'
import Logo from './Logo'

export default {
  components: {
    LocaleDropdown, Logo
  },

  data: () => ({
    appName: window.config.appName,
    toggleAdmin: false,
    toggleUser: false
  }),

  computed: mapGetters({
    user: 'auth/user',
    company: 'auth/company'
  }),

  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .navbar-brand {
      padding-top: .75rem;
      padding-bottom: .75rem;
      background-color: rgba(0, 0, 0, .25);
      box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
      font-size: 1.53125rem;
      font-weight: bold;
      a {
        color: #fff;
      }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Navbar.vue